/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/addRepo/AddRepoPicker.Props" />
import { ExternalGitRepo } from "Wit/Clients/Internal/Contracts/ExternalEvents";

/**
 * Add repository picker props
 */
export interface IAddRepoPickerProps {
    serviceEndpointId?: string;
    isGitHubApp: boolean;
    isUnifiedGitHubApp?: boolean;
    selectedReposFromSameProvider?: ExternalGitRepo[];
    onAddReposSelectionChanged: (selectedRepos: ExternalGitRepo[]) => void;
    repositoryType: string;
    onError: (error: Error) => void;
    shouldPreselectRepo?: boolean;
    orgOrUserName?: string;
    isUserType?: boolean;
}
